import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { MyEventModel } from '../../types';
import { BText, Drawer } from '../';
import { Button, ButtonContainer } from '../Form';
import { formatTime24 } from '../../utils/dateUtils';
import { themeConfig } from '../../styles/themeConfig';
import { CancelRegistration } from './CancelRegistration';
import { OrganizerContacts } from './OrganizerContacts';
//import OrganizerContacts from '../OrganizerContacts/index.tsx.bak';
//import CancelRegistration from '../CancelRegistration/index.tsx.bak';

type props = {
  event: MyEventModel;
  onClose?: any;
  showClose?: boolean;
  showActions?: boolean;
};

export const RegistrationDetail = ({ event, onClose = () => null, showClose = false, showActions = false }: props) => {
  //const [registeredEvent, setEvent] = useState<EventModel>(event);
  const [showCancellation, setShowCancellation] = useState<boolean>(false);
  const [showOrganizer, setShowOrganizer] = useState<boolean>(false);

  /*useEffect(() => {
    if (event) {
      setEvent(event);
    }
  }, [event]);
*/
  return (
    <>
      {event && (
        <View style={styles.container}>
          <BText style={styles.title}>Registration Details</BText>
          <View style={styles.regInfoContainer}>
            <View style={styles.fieldContainer}>
              <BText style={styles.fieldLabel}>Registration number</BText>
              <BText style={styles.fieldText}>{event.ticketNumber}</BText>
            </View>
            <View style={styles.fieldContainer}>
              <BText style={styles.fieldLabel}>Registration date</BText>
              <BText style={styles.fieldText}>
                {event.registrationDisplayDate}
                {'\n'}
                {formatTime24(event.createdDate || '')}
              </BText>
            </View>
          </View>

          <ButtonContainer containerStyle={styles.buttonContainer}>
            {showActions && (
              <>
                <Button onPress={() => setShowOrganizer(true)}>Contact Organizer</Button>
                <Button onPress={() => setShowCancellation(true)}>Cancel Registration</Button>
              </>
            )}
            {showClose && <Button onPress={onClose}>Close</Button>}
          </ButtonContainer>
        </View>
      )}
      <Drawer
        id="reg-details-contacts"
        visible={showOrganizer}
        title="Contact Event Organizer"
        onClose={() => setShowOrganizer(false)}
      >
        <OrganizerContacts organizer={event.event.organizer} onClose={() => setShowOrganizer(false)} />
      </Drawer>

      <Drawer
        id={'reg-details-cancellation'}
        visible={showCancellation}
        onClose={() => setShowCancellation(false)}
        title="Cancel Registration"
      >
        <CancelRegistration onClose={() => setShowCancellation(false)} />
      </Drawer>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: '100%',
    height: 230,
    borderRadius: themeConfig.settings.borderRadius,
    backgroundColor: themeConfig.colors.white,
    paddingTop: 24,
    paddingBottom: 16,
    paddingHorizontal: 16,
    flex: 1,
    justifyContent: 'space-between',
  },
  title: {
    fontSize: 14,
    fontWeight: 'bold',
    paddingBottom: 8,
  },
  regInfoContainer: {
    paddingBottom: 30,
  },
  fieldContainer: {
    paddingTop: 8,
    flexDirection: 'row',
  },
  fieldLabel: {
    flex: 1,
    fontSize: 14,
  },
  fieldText: {
    fontSize: 14,
    color: themeConfig.colors.grey,
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
  buttonContainer: {
    alignSelf: 'stretch',
    marginTop: 20,
  },
});
